import classNames from 'classnames';
import styles from './slide.module.css';
import ResilientImage from 'components/shared/media/ResilientImage';

const Slide = (item) => {

    if(item?.url) {
        return (
                <ResilientImage
                    className={classNames('image-gallery-image', styles.slide)}
                    src={item?.url_tiny ?? item?.url}
                    backupSrc={item?.backup_url_tiny ?? item?.backup_url}
                    alt=''
                    preferenceKey={`gallery-slide:${item?.id || item?.url || 'url'}`}
                />

        );
    }

  if(item?.original) {
      return (
          item?.original && (
              <ResilientImage
                  className={classNames('image-gallery-image', styles.slide)}
                  src={item?.original}
                  backupSrc={item?.backup_original || item?.backup_url}
                  alt=''
                  preferenceKey={`gallery-slide:${item?.id || item?.original || 'original'}`}
              />
          )
      );
  }
};

export default Slide;
